<template>
  <a-modal
    :visible="true"
    @cancel="onCancel"
    :maskClosable="false"
    :width="800"
    @ok="onSubmitEvent"
    :body-style="{ maxHeight: '80vh', overflowY: 'auto' }"
    :title="item&&item.flowId?'编辑审批流':'新建审批流'">
    <a-form-model
      ref="form" :model="form"
      :rules="editRules"

      class="withdraw-form">
      <a-form-model-item
        label="所属部门" prop="deptId"
        :label-col="labelCol"
        :wrapper-col="wrapperCol">
        <a-tree-select
          style="width: 100%"
          v-model:value="form['deptId']"
          placeholder="请选择部门"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          allow-clear
          tree-default-expand-all
          :replaceFields="{
              children:'children',
              title:'deptName',
              key:'deptId',
              value: 'deptId'
          }"
          :tree-data="deptTreeData"
        >
        </a-tree-select>
      </a-form-model-item>
      <a-card
        :title="group.stepOrder+'审'"
        style="width: 100%;margin-top: 20px"
        v-for="(group,groupIndex) in form.item"
        :key="group.stepOrder">
        <a-form-model-item
          label="审核人"
          :prop="'item.' + groupIndex + '.auditorValues'"
          :rules="{ required: true, validator: handleStepOrder, trigger: 'change,blur'}"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-textarea
            style="width: 100%"
            :rows="4"
            placeholder="请输入邮箱或手机号，并列多人审核可换行设置"
            v-model:value="group.auditorValues"></a-textarea>

        </a-form-model-item>
        <a-form-model-item
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          label="抄送人">
          <a-textarea
            style="width: 100%"
            :rows="4"
            placeholder="请输入邮箱或手机号，并列多人抄送可换行设置"
            v-model:value="group.copyValues"></a-textarea>
        </a-form-model-item>
      </a-card>
      <a-form-model-item
        v-if="form.item.length<3"
        label=" "
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        style="margin-top: 20px"
        :colon="false">
        <a-button type="dashed" style="width: 60%" @click="addFlowEvent">
          <a-icon type="plus"/>
          添加多级审核
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import searchForm from '@/utils/mixins/searchFormMixins'
import deptMixins from '@/views/platform/employeeVerification/mixins/deptMixins'
import ValidatorHelper from '@/utils/helper/validatorHelper'

export default {
  name: 'FlowCreatorDialog',
  mixins: [searchForm, deptMixins],
  props: {
    value: {
      type: String,
      default: '',
      required: true
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    editConfigList: {
      type: Array,
      default: () => {
        return []
      }
    },
    rules: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      form: {
        deptId: undefined,
        item: [
          {
            auditorValues: '',
            copyValues: '',
            stepOrder: 1
          }
        ]
      },
      editRules: {
        deptId: [
          { required: true, message: '请选择部门', trigger: 'change,blur' }
        ],
        item: [
          { required: true, message: '请输入审批人', trigger: 'change,blur' },
          { required: true, validator: this.handleStepOrder }
        ]
      },
      labelCol: { span: 3 },
      wrapperCol: { span: 21 }
    }
  },
  created() {
    this.enterpriseId = this.value
  },
  mounted() {
  },
  methods: {
    handleStepOrder(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入审批人'))
      } else {
        let showErrorMsg = ''
        const list = value.split(/[\r\n]+/).filter(i => !!i)
        for (let i = 0; i < list.length; i++) {
          const itemValue = list[i]
          if (!ValidatorHelper.isEmail(itemValue) && !ValidatorHelper.validateMobile(itemValue)) {
            showErrorMsg = itemValue + ' 格式有误！'
            break
          }
        }
        if (!showErrorMsg) {
          callback()
        } else {
          callback(new Error(showErrorMsg))
        }
      }
    },
    requestSave() {
      const url = 'member/v3/auth/saveAuthApprovalStep'
      const params = {
        ...this.form,
        enterpriseId: this.value,
        item: this.form.item.map(i => {
          return {
            stepOrder: i.stepOrder,
            auditorValues: i.auditorValues.split(/[\r\n]+/).filter(i => !!i),
            copyValues: i.copyValues.split(/[\r\n]+/).filter(i => !!i)
          }
        })
      }
      this.getHttpServices().getMemberAuthService().post(url, params)
        .then(res => {
          this.onCancel()
          this.$emit('ok')
          this.$message.success('操作成功')
        })
        .catch(err => {
          if (err.msg) {
            this.$message.error(err.msg)
          } else {
            this.$message.error('操作失败，请重试！')
          }
          console.error(err)
        })
    },
    addFlowEvent() {
      this.form.item.push({
        auditorValues: '',
        stepOrder: this.form.item.length + 1
      })
    },
    onSubmitEvent() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.requestSave()
        } else {
          this.$message.error('请完善表单信息！')
        }
      })
    },
    onCancel() {
      this.$emit('cancel')
    }
  }
}
</script>


<style scoped lang="less">

</style>